import React from 'react'
import FontAwesome from 'react-fontawesome'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

export default class PropertyTitle extends React.Component {

  render() {
    const { icon, text, link, small, className } = this.props
    return <span className={classNames('property-title', {'small': small}, className)}>
      { icon && <FontAwesome name={icon} size='2x'/> }
      { link ? <Link to={link}><span className='text'>{text}</span></Link>
      : <span className='text'>{text}</span>}

    </span>
  }
}
